import { render } from "./QADetailView.vue?vue&type=template&id=1946e372&ts=true"
import script from "./QADetailView.vue?vue&type=script&lang=ts"
export * from "./QADetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__